import useStores from 'shared/hooks/use-stores';

export default function useUI() {
  const { UI } = useStores();

  return UI;
}
